import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { }

export default class TagGroupListPage extends Component<Props>
{
    override render()
    {
        return (
            <ErpLayout {...this.props} mode={ErpScopeMode.Filter} fields={[ErpScopeField.Company, ErpScopeField.Branch]} pages={{ entity: ErpEntities.tag_group(this.props), list: {} }}><></></ErpLayout>
        );
    }
}